<template>
  <div class="foot-ct">
    <div class="link" v-if="!(Config.hiddenAuths||'').includes('foot-link')">
      <div style="    justify-content: space-between;
    display: flex;">
        <div v-for="(item, index) in webContent.footers" :key="`footer-${index}`">
          <div class="foot-title">{{item.title[$i18n.locale]}}</div>
          <div
            class="foot-list"
            v-for="(content, index) in item.contents"
            :key="`content-${index}`"
          >
            <a
              class="text-link"
              target="_blank"
              :href="content.link"
            >{{content.title[$i18n.locale]}}</a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!(Config.hiddenAuths||'').includes('foot-link')" class="foot-line"></div>
    <Row v-if="$store.getters.webConfig.showBottomPartners" class="partner">
        <Col class="partner-logo"><img src="../../assets/image/index/7.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/6.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/5.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/4-1.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/3-p.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/cmt.png"></Col>
        <Col class="partner-logo"><img src="../../assets/image/index/1-2.png"></Col>
    </Row>
    <div v-if="(Config.hiddenAuths||'').includes('foot-partner')" style="margin-top:0.36rem;"></div>
    <div v-if="(Config.hiddenAuths||'').includes('foot-partner')" style="margin-top:0.36rem;"></div>

    <div class="copy">Copyright © {{currentYear}} {{$store.getters.webConfig.websiteName}} All Rights Reserved.</div>
  </div>
</template>

<script>
import Config from '@/utils/Config';
import moment from 'moment';

export default {
    name: 'Footer',
    data() {
        return {
            Config,
        };
    },
    computed:{
        currentYear: ()=>moment().year(),
        webContent() {
            return this.$store.state.webContent;
        },
    },
};
</script>

<style lang="less">
@import '../../../static/style/color.less';
@import '../../../static/style/preset.less';
@import '../../../static/style/lib.less';
@import '../../../static/style/foot.less';
@import '../../../static/style/media.less';
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue